const exactSpaRoutes = new Set([
  '/summary/',
  '/ab/',
  '/ad/',
  '/ad/affise-recalc/',
  '/ad/blacklist/',
  '/ad/recalc/queue/',
  '/ad/revshare/',
  '/ad/spots/',
  '/ad/tabular/',
  '/ltv/',
  '/payments/',
  '/payments/game-days/',
  '/payments/raw/',
  '/payments/top-users/',
  '/payments/per-hour/',
  '/postbacks/',
  '/reports/',
  '/reports/adwheel/',
  '/retention/',
  '/retention/export/',
  '/retension/export/',
  '/users/',
  '/mx/hourly/',
  '/mx/sessions/',
  '/mx/settings/blacklist/',
])

const prefixedSpaRoutes = [
  '/ad/expenses/',
  '/ad/blacklist/',
  '/ad/mapping/',
  '/ad/recalc/queue/',
  '/ad/revshare/',
  '/ad/spots/',
  '/reports/',
  '/users/',
]

export function isSpaRoute(url: string) {
  if (exactSpaRoutes.has(url)) {
    return true
  }

  return prefixedSpaRoutes.some((prefix) => url.startsWith(prefix))
}
